import CONSTANT from 'modules/constant'
import type { OneStopHyundaiItemProps, SaveOneStopHyundaiPayload } from 'modules/types'
import { API, headers } from './api'

export const oneStopHyundaiApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getOneStopHyundaiMenus: builder.query<OneStopHyundaiItemProps[], void>({
      query: () => ({
        url: CONSTANT.URL_ONE_STOP_HYUNDAI_MENUS,
        method: 'GET',
        headers: headers()
      }),
      providesTags: ['OneStopHyundai']
    }),
    saveOneStopHyundai: builder.mutation<void, SaveOneStopHyundaiPayload>({
      query: (payload) => ({
        url: CONSTANT.URL_ONE_STOP_HYUNDAI_SAVE,
        method: 'POST',
        headers: headers(),
        body: payload
      }),
      invalidatesTags: ['OneStopHyundai']
    })
  })
})

export const { useGetOneStopHyundaiMenusQuery, useSaveOneStopHyundaiMutation } = oneStopHyundaiApi
